import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { FamilyTree, NodePosition } from '../../../app/api/generated/client';
import { updateNodePosition } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';

interface IUpdateNodePositionRequest {
    nodeUuid: string;
    newPosition: NodePosition;
    isConnectorNode: boolean;
}

export function useUpdateNodePosition(mainPartnerUuid: string): UseMutationResult<void, AxiosError, IUpdateNodePositionRequest> {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ nodeUuid, newPosition }) => {
            await updateNodePosition({ path: { mainPartnerUuid, nodeUuid }, body: newPosition });
        },
        onSuccess: (_, { nodeUuid, newPosition, isConnectorNode }) => {
            queryClient.setQueryData(queryKeys.familyTree(mainPartnerUuid), (familyTree: FamilyTree) => {
                if (!familyTree) return familyTree;

                return {
                    ...familyTree,
                    [isConnectorNode ? 'connectorNodes' : 'partnerNodes']: familyTree.partnerNodes.map((node) =>
                        node.uuid === nodeUuid ? { ...node, nodePosition: newPosition } : node,
                    ),
                };
            });
        },
    });
}
